import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSnowRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4753 8.24102C22.4233 8.24102 22.3734 8.24694 22.3221 8.24891C21.7453 5.81373 19.5633 4 16.9519 4C14.2076 4 11.9375 6.00181 11.5074 8.62376C11.1648 8.5284 10.8051 8.47382 10.4322 8.47382C8.53235 8.47382 6.94616 9.79959 6.5404 11.5758C5.05417 12.1598 4 13.602 4 15.2947C4 17.4997 5.78874 19.2898 7.99573 19.2898H22.4753C25.5273 19.2898 28 16.8164 28 13.7657C28 10.715 25.5273 8.24036 22.4753 8.24036V8.24102Z"
        fill="white"
      />
      <path
        d="M10.3678 26.2737C10.1219 26.9478 10.4592 27.3864 11.0005 27.5837C11.541 27.781 12.0816 27.6607 12.3269 26.9866C12.5715 26.3125 12.2019 24.2811 12.2019 24.2811C12.2019 24.2811 10.6131 25.5997 10.3678 26.2737Z"
        fill="white"
      />
      <path
        d="M16.0819 26.2737C15.8359 26.9478 16.1733 27.3864 16.7139 27.5837C17.2551 27.781 17.7957 27.6607 18.0409 26.9866C18.2856 26.3125 17.916 24.2811 17.916 24.2811C17.916 24.2811 16.3272 25.5997 16.0819 26.2737Z"
        fill="white"
      />
      <path
        d="M9.50017 23.5032C10.1463 23.3507 10.5465 22.7032 10.394 22.057C10.2415 21.4109 9.59405 21.0107 8.94789 21.1632C8.30172 21.3157 7.90153 21.9632 8.05404 22.6093C8.20655 23.2555 8.854 23.6557 9.50017 23.5032Z"
        fill="white"
      />
      <path
        d="M15.7883 23.1804C16.2578 22.7109 16.2578 21.9497 15.7883 21.4803C15.3189 21.0108 14.5577 21.0108 14.0883 21.4803C13.6188 21.9497 13.6188 22.7109 14.0883 23.1804C14.5577 23.6498 15.3189 23.6498 15.7883 23.1804Z"
        fill="white"
      />
      <path
        d="M20.9292 23.5038C21.5753 23.3513 21.9755 22.7038 21.823 22.0576C21.6705 21.4115 21.0231 21.0113 20.3769 21.1638C19.7307 21.3163 19.3305 21.9638 19.4831 22.6099C19.6356 23.2561 20.283 23.6563 20.9292 23.5038Z"
        fill="white"
      />
    </svg>
  );
}
